import React, { useEffect, useState } from 'react';
import { getAllBlogPosts } from '../services/blogService';
import { BlogCard, BlogPost } from '../components/BlogCard';
import { MetaTagsManager } from '../components/MetaTagsManager';
export const BlogPage: React.FC = () => {
  const [posts, setPosts] = useState<BlogPost[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    const fetchPosts = async () => {
      try {
        setLoading(true);
        const data = await getAllBlogPosts();
        setPosts(data);
        setError(null);
      } catch (err) {
        console.error('Error fetching blog posts:', err);
        setError('Failed to load blog posts. Please try again later.');
      } finally {
        setLoading(false);
      }
    };
    fetchPosts();
  }, []);
  return <>
      <MetaTagsManager data-id="element-374" />
      <div className="bg-gray-50 py-16" data-id="element-375">
        <div className="container mx-auto px-4" data-id="element-376">
          <div className="text-center mb-12" data-id="element-377">
            <span className="inline-block px-4 py-1.5 rounded-full bg-blue-100 text-blue-700 font-semibold text-sm mb-4" data-id="element-378">
              OUR BLOG
            </span>
            <h1 className="text-3xl md:text-5xl font-bold text-gray-800 mb-5" data-id="element-379">
              HVAC Insights & Tips
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-380">
              Stay informed with the latest HVAC industry news, maintenance
              tips, and energy-saving strategies.
            </p>
          </div>
          {loading ? <div className="flex justify-center items-center h-64" data-id="element-381">
              <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-600" data-id="element-382"></div>
            </div> : error ? <div className="bg-red-100 text-red-700 p-4 rounded-md text-center max-w-lg mx-auto" data-id="element-383">
              {error}
            </div> : <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-384">
              {posts.map(post => <BlogCard key={post.id} post={post} data-id="element-385" />)}
            </div>}
        </div>
      </div>
    </>;
};